import React, { useState, useEffect } from "react";
import "./styles.less";
// import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import { blogAxios } from "../../utils/blogAxios";
import qs from "qs";
import { getListParams } from "./getListParams";
import { List } from "./List";

let isFirstTime = true;

export const BlogList = (props) => {
  const { articleList, query: serverQuery, categories, articleTotalCount } = props;

  const [query, setQuery] = useState(serverQuery || getListParams());
  const [total, setTotal] = useState(articleTotalCount || 0);
  // const { t } = useTranslation();
  const [blogList, setBlogList] = useState(articleList || []);
  const [listMenu, setListMenu] = useState(categories || []);
  const { search } = useLocation();
  const [page, setPage] = useState(Number(new URLSearchParams(search).get("page")) || 1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const nextQ = getListParams();
    if (JSON.stringify(nextQ) !== JSON.stringify(query)) {
      setQuery(nextQ);
    }
  }, [query, search]);

  useEffect(() => {
    if (isFirstTime && articleList) {
      isFirstTime = false;
      return;
    }

    setLoading(true);

    const searchString = qs.stringify(query);

    const promise1 = blogAxios.get(`/articles?${searchString}`).then(({ data }) => {
      setBlogList(data);
    });
    const promise2 = blogAxios.get(`/articles/count?${searchString}`).then(({ data }) => {
      setTotal(data);
    });

    Promise.all([promise1, promise2]).finally(() => {
      setLoading(false);
    });
  }, [articleList, query, setLoading]);

  useEffect(() => {
    blogAxios.get("/categories").then(({ data }) => {
      setListMenu(data);
    });
  }, [categories]);

  return (
    <section
      style={{
        flex: 1,
        minWidth: 0,
      }}
    >
      <div className="blog-list-warp">
        <div className="blog-list-menu">
          <div
            key={-1}
            className={classnames({
              "menu-item": true,
              selected: !query.category,
            })}
            onClick={() => {
              navigate(`/blog`);
            }}
          >
            最新
          </div>
          {listMenu?.map((item) => {
            const cls = classnames({
              "menu-item": true,
              selected: query.category === item.id,
            });
            return (
              <div
                key={item.id}
                className={cls}
                onClick={() => {
                  navigate(`/blog?category=${item.id}`);
                }}
              >
                {item.name}
              </div>
            );
          })}
        </div>
        <List
          {...{
            loading,
            setPage,
            blogList,
            page,
            total,
          }}
        />
      </div>
    </section>
  );
};
